import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
import auth from "../../../common/utility/auth";

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">

                            {auth.user().id == row.idUsuario ? (

                                <Tooltip placement="top" title={"Arqueo Caja"}>
                                    <Button
                                        type="success"
                                        icon="check-square"
                                        size={"small"}
                                        loading={props.loadingClose}
                                        onClick={() => props.onViewCierre(row)}
                                    />
                                </Tooltip>

                            ) :
                                <Tooltip placement="top" title={"Arqueo Caja"}>
                                    <Button
                                        type="success"
                                        icon="check-square"
                                        size={"small"}
                                        loading={props.loadingClose}
                                        disabled={(row.idCajaEstado == 3 || row.idCajaEstado == 5)?true:false}
                                        onClick={() => props.onViewCierre(row)}
                                    />
                                </Tooltip>
                            }



        
                            {row.idCajaEstado == 5 || row.idCajaEstado == 3 ? (
                                
                                <Tooltip placement="top" title={"Anexo"}>
                                <Button
                                    type="primary"
                                    icon="check-circle"
                                    size={"small"}
                                    onClick={() => props.onAnexo(row)}
                                />
                            </Tooltip>

                            ) : null}


                         
                            {row.idCajaEstado == 5 || row.idCajaEstado == 4 ? (

                                <Tooltip placement="top" title="Imprimir">
                                    <Button
                                        loading={props.loadingPrint}
                                        type="primary"
                                        icon="printer"
                                        size={"small"}
                                        onClick={() => props.onImprimir(row)}
                                    />
                                </Tooltip>


                            ) : null}



                        </div>
                    )
                },
        
                {
                    title: 'Nro Planilla ',
                    dataIndex: 'nroSerie_correlativo' ,
                    key: 'nroSerie_correlativo',
                    sorter: true
                },
                {
                    title: 'Establecimiento',
                    dataIndex: 'establecimiento',
                    key: 'establecimiento',
                    sorter: true
                },
                {
                    title: 'Caja',
                    dataIndex: 'caja',
                    key: 'caja',
                    sorter: true
                },
                {
                    title: 'Responsable Caja',
                    dataIndex: 'empleado',
                    key: 'empleado',
                    sorter: true
                },
                {
                    title: 'Fecha Apertura',
                    dataIndex: 'fecha',
                    key: 'fecha',
                    sorter: true,
                    render: (value, row) => {

                        return (<span>{value} {row.hora} </span>)
                    }
                },
           
                {
                    title: 'Estado',
                    dataIndex: 'idCajaEstado',
                    key: 'flag',
                    align: 'center',
                    width: "90px",
                    render: (value,row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                switch (value) {
                                    case 1: //registado
                                        return <Tag color={"green"}>{row.cajaEstado}</Tag>;
                                    case 2://ANULADA
                                        return <Tag color={"red"}>{row.cajaEstado}</Tag>;
                                    case 3://APERTURADA
                                        return <Tag color={"blue"}>{row.cajaEstado}</Tag>;
                                    case 4://CERRADO
                                        return <Tag color={"orange"}>{row.cajaEstado}</Tag>;
                                    case 5://POR CERRAR
                                        return <Tag color={"blue"}>{row.cajaEstado}</Tag>;
                                    default:
                                        return null;
                                }
                            })()}

                        </div>)
                    }
                }
            ]}
        />
    );
}